<template>
  <div
    class="bg-page-loader"
    :class="overlayClass"
    role="status"
    aria-live="polite"
    :aria-label="text"
  >
    <div class="bg-page-loader__panel">
      <div class="bg-page-loader__spinner-wrap" aria-hidden="true">
        <img
          :src="loaderSpinnerUrl"
          alt=""
          class="bg-page-loader__spinner"
        >
      </div>
      <p class="bg-page-loader__text">{{ text }}</p>
      <div class="bg-page-loader__bar" aria-hidden="true">
        <span class="bg-page-loader__bar-fill" />
      </div>
    </div>
  </div>
</template>

<script>
import { LOADER_SPINNER_URL } from '@/constants/brandAssets'

export default {
  name: 'BlackGoldPageLoader',
  props: {
    text: {
      type: String,
      default () {
        return this.$t('common.loading')
      }
    },
    overlayClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loaderSpinnerUrl: LOADER_SPINNER_URL
    }
  }
}
</script>
